import { createTuyau } from '@tuyau/core/client'
import { createTuyauReactQueryClient } from '@tuyau/react-query'
import { registry } from 'gozoki-backend/registry'
import { getToken } from '~/utils/api'

export const tuyauClient = createTuyau({
  baseUrl: import.meta.env.VITE_BACKEND_API_ENDPOINT,
  registry,
  // ky defaults to a 10s request timeout, which is too short for slow endpoints
  // (e.g. the Unify camera sync). Align with the legacy axios client, which used
  // 120s for every request.
  timeout: 120_000,
  headers: {
    'Content-Type': 'application/json',
  },
  hooks: {
    beforeRequest: [
      async (request) => {
        const token = await getToken()
        if (token) request.headers.set('Authorization', `Bearer ${token}`)
      },
    ],
  },
})

export const api = createTuyauReactQueryClient({ client: tuyauClient })
